export const Consts = {
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,

  // Note: serverBaseUrl and analyticsServerBaseUrl are now dynamically determined
  // from auth response and managed in ConfigStore - no longer constants
  authBaseUrl: import.meta.env.VITE_AUTH_BASE_URL,
  posthogHost: import.meta.env.VITE_POSTHOG_HOST,
  posthogKey: import.meta.env.VITE_POSTHOG_KEY,
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  captchaSitekey: import.meta.env.VITE_FRIENDLY_CAPTCHA_SITEKEY,

  // Billing update polling configuration
  polling: {
    maxAttempts: 10,
    intervalMs: 500,
  },
} as const
